module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 20 24\"><path d=\"M19 6h-1.09l-1.805 16.117A2.143 2.143 0 0 1 14 24H6a2.14 2.14 0 0 1-2.104-1.885L2.12 6H1a1 1 0 0 1 0-2h5V3c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3v1h5a1 1 0 0 1 0 2zm-7-3c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v1h4V3zM4.132 6l1.753 15.897c.004.04.075.103.115.103h8c.04 0 .113-.065.118-.105L15.898 6H4.132z\" class=\"cls-1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/delete.svg
// module id = fZJU
// module chunks = 89